/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Tabs_Installoptions1Inputs */

const id_builds_tabs_installoptions1 = /** @type {(inputs: Builds_Tabs_Installoptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opsi Instalasi`)
};

const ms_builds_tabs_installoptions1 = /** @type {(inputs: Builds_Tabs_Installoptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilihan Pemasangan`)
};

const da_builds_tabs_installoptions1 = /** @type {(inputs: Builds_Tabs_Installoptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Installationsmuligheder`)
};

const de_builds_tabs_installoptions1 = /** @type {(inputs: Builds_Tabs_Installoptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Installationsoptionen`)
};

const en_us2_builds_tabs_installoptions1 = /** @type {(inputs: Builds_Tabs_Installoptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Install Options`)
};

const es_es2_builds_tabs_installoptions1 = /** @type {(inputs: Builds_Tabs_Installoptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opciones de instalación`)
};

const es_mx2_builds_tabs_installoptions1 = /** @type {(inputs: Builds_Tabs_Installoptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opciones de instalación`)
};

const fil_builds_tabs_installoptions1 = /** @type {(inputs: Builds_Tabs_Installoptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Opsyon sa Pag-install`)
};

const fr_builds_tabs_installoptions1 = /** @type {(inputs: Builds_Tabs_Installoptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Options d'installation`)
};

const it_builds_tabs_installoptions1 = /** @type {(inputs: Builds_Tabs_Installoptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opzioni di installazione`)
};

const hu_builds_tabs_installoptions1 = /** @type {(inputs: Builds_Tabs_Installoptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telepítési opciók`)
};

const nl_builds_tabs_installoptions1 = /** @type {(inputs: Builds_Tabs_Installoptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Installatieopties`)
};

const no_builds_tabs_installoptions1 = /** @type {(inputs: Builds_Tabs_Installoptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Installasjonsalternativer`)
};

const pl_builds_tabs_installoptions1 = /** @type {(inputs: Builds_Tabs_Installoptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opcje instalacji`)
};

const pt_br2_builds_tabs_installoptions1 = /** @type {(inputs: Builds_Tabs_Installoptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opções de instalação`)
};

const pt_builds_tabs_installoptions1 = /** @type {(inputs: Builds_Tabs_Installoptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opções de instalação`)
};

const ro_builds_tabs_installoptions1 = /** @type {(inputs: Builds_Tabs_Installoptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opțiuni de instalare`)
};

const fi_builds_tabs_installoptions1 = /** @type {(inputs: Builds_Tabs_Installoptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asennusasetukset`)
};

const sv_builds_tabs_installoptions1 = /** @type {(inputs: Builds_Tabs_Installoptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Installationsalternativ`)
};

const vi_builds_tabs_installoptions1 = /** @type {(inputs: Builds_Tabs_Installoptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tùy chọn cài đặt`)
};

const tr_builds_tabs_installoptions1 = /** @type {(inputs: Builds_Tabs_Installoptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurulum Seçenekleri`)
};

const cs_builds_tabs_installoptions1 = /** @type {(inputs: Builds_Tabs_Installoptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Možnosti instalace`)
};

const bg_builds_tabs_installoptions1 = /** @type {(inputs: Builds_Tabs_Installoptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Опции за инсталиране`)
};

const ru_builds_tabs_installoptions1 = /** @type {(inputs: Builds_Tabs_Installoptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Параметры установки`)
};

const uk_builds_tabs_installoptions1 = /** @type {(inputs: Builds_Tabs_Installoptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Параметри встановлення`)
};

const ar_builds_tabs_installoptions1 = /** @type {(inputs: Builds_Tabs_Installoptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خيارات التثبيت`)
};

const hi_builds_tabs_installoptions1 = /** @type {(inputs: Builds_Tabs_Installoptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इंस्टॉल विकल्प`)
};

const th_builds_tabs_installoptions1 = /** @type {(inputs: Builds_Tabs_Installoptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตัวเลือกการติดตั้ง`)
};

const ja_builds_tabs_installoptions1 = /** @type {(inputs: Builds_Tabs_Installoptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インストールオプション`)
};

const zh_cn2_builds_tabs_installoptions1 = /** @type {(inputs: Builds_Tabs_Installoptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安装选项`)
};

const zh_hant1_builds_tabs_installoptions1 = /** @type {(inputs: Builds_Tabs_Installoptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安裝選項`)
};

const ko_builds_tabs_installoptions1 = /** @type {(inputs: Builds_Tabs_Installoptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`설치 옵션`)
};

/**
* | output |
* | --- |
* | "Install Options" |
*
* @param {Builds_Tabs_Installoptions1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_tabs_installoptions1 = /** @type {((inputs?: Builds_Tabs_Installoptions1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Tabs_Installoptions1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_tabs_installoptions1(inputs)
	if (locale === "ms") return ms_builds_tabs_installoptions1(inputs)
	if (locale === "da") return da_builds_tabs_installoptions1(inputs)
	if (locale === "de") return de_builds_tabs_installoptions1(inputs)
	if (locale === "en-US") return en_us2_builds_tabs_installoptions1(inputs)
	if (locale === "es-ES") return es_es2_builds_tabs_installoptions1(inputs)
	if (locale === "es-MX") return es_mx2_builds_tabs_installoptions1(inputs)
	if (locale === "fil") return fil_builds_tabs_installoptions1(inputs)
	if (locale === "fr") return fr_builds_tabs_installoptions1(inputs)
	if (locale === "it") return it_builds_tabs_installoptions1(inputs)
	if (locale === "hu") return hu_builds_tabs_installoptions1(inputs)
	if (locale === "nl") return nl_builds_tabs_installoptions1(inputs)
	if (locale === "no") return no_builds_tabs_installoptions1(inputs)
	if (locale === "pl") return pl_builds_tabs_installoptions1(inputs)
	if (locale === "pt-BR") return pt_br2_builds_tabs_installoptions1(inputs)
	if (locale === "pt") return pt_builds_tabs_installoptions1(inputs)
	if (locale === "ro") return ro_builds_tabs_installoptions1(inputs)
	if (locale === "fi") return fi_builds_tabs_installoptions1(inputs)
	if (locale === "sv") return sv_builds_tabs_installoptions1(inputs)
	if (locale === "vi") return vi_builds_tabs_installoptions1(inputs)
	if (locale === "tr") return tr_builds_tabs_installoptions1(inputs)
	if (locale === "cs") return cs_builds_tabs_installoptions1(inputs)
	if (locale === "bg") return bg_builds_tabs_installoptions1(inputs)
	if (locale === "ru") return ru_builds_tabs_installoptions1(inputs)
	if (locale === "uk") return uk_builds_tabs_installoptions1(inputs)
	if (locale === "ar") return ar_builds_tabs_installoptions1(inputs)
	if (locale === "hi") return hi_builds_tabs_installoptions1(inputs)
	if (locale === "th") return th_builds_tabs_installoptions1(inputs)
	if (locale === "ja") return ja_builds_tabs_installoptions1(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_tabs_installoptions1(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_tabs_installoptions1(inputs)
	return ko_builds_tabs_installoptions1(inputs)
});
export { builds_tabs_installoptions1 as "builds.tabs.installOptions" }